import {
  blupayApi,
  getApiError,
} from "../api/client";

export const publicQuoteService = {
  async preview(payload) {
    try {
      const { data } =
        await blupayApi.post(
          "/public/quotes/",
          payload
        );

      return data;
    } catch (error) {
      throw getApiError(error);
    }
  },
};